module.exports = __webpack_public_path__ + "Roboto-Medium-webfont.88e897b6e48f9b57cbed.svg";


//////////////////
// WEBPACK FOOTER
// C:/Users/gfurtado/Projects/v2.3 (ng4 2.1 only)/Angular 4 CLI/app/src/assets/fonts/roboto/Roboto-Medium-webfont.svg
// module id = ../../../../../src/assets/fonts/roboto/Roboto-Medium-webfont.svg
// module chunks = styles